import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { ExternalLink, Heart } from 'lucide-react';

export const KGOBCares = () => {
  return (
    <section 
      id="cares"
      className="bg-[#F7F6F2] py-16 lg:py-20 overflow-x-hidden"
      data-testid="kgob-cares-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(11,34,64,0.18)]">
              <img 
                src="/assets/images/cc3148cb-c6dc-4c67-abe6-f33d83ed32a2.png" 
                alt="KGOB Cares - Community education and support"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B2240]/60 to-transparent"></div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7 space-y-6"
          >
            <div className="flex items-center space-x-2">
              <Heart className="h-6 w-6 text-[#D4AF37]" fill="#D4AF37" />
              <p className="uppercase tracking-[0.18em] text-xs text-[#4C5A70]">
                KGOB CARES
              </p>
            </div>
            
            <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0B2240]">
              KGOB Cares — Because True Success Gives Back.
            </h2>
            
            <p className="text-lg text-[#4C5A70] leading-relaxed">
              Through If You Teach Me, we invest in financial literacy for families and children — empowering the next generation to build balanced, purposeful lives.
            </p>
            
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-2"></div>
                <p className="text-[#4C5A70]">
                  <span className="font-semibold text-[#0B2240]">Pro Bono Services:</span> Free tax prep and advisory for qualifying nonprofits
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-2"></div>
                <p className="text-[#4C5A70]">
                  <span className="font-semibold text-[#0B2240]">Scholarship Programs:</span> Supporting accounting students from diverse backgrounds
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-2"></div>
                <p className="text-[#4C5A70]">
                  <span className="font-semibold text-[#0B2240]">Community Workshops:</span> Financial literacy for entrepreneurs and families
                </p>
              </div>
            </div>
            
            <Button
              asChild
              className="h-12 px-8 rounded-xl bg-[linear-gradient(180deg,#E8D89E_0%,#D4AF37_50%,#B99610_100%)] text-[#0B2240] hover:brightness-95 shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] focus-visible:ring-2 focus-visible:ring-[#1FA3A3] font-medium"
              data-testid="kgob-cares-external-link"
            >
              <a data-testid="k-g-o-b-cares-a-1" 
                href="https://ifyouteachme.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center"
              >
                Visit If You Teach Me
                <ExternalLink className="ml-2 h-4 w-4" />
              </a>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};